/**************************************************************************************************/
/*   File: /src/app/shared/models/message.ts                                                      */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { MessagePositionEnum, MessageType } from '../enums';

/**
 * The message
 */
export class Message {
    /**
     * The message type
     */
    messageType: MessageType;
    /**
     * The message key
     */
    messageTextKey: string;
    /**
     * The message position in page
     */
    position: MessagePositionEnum;
    /**
     * The state name
     */
    stateName: string;
    /**
     * The isClosable
     */
    isClosable: boolean;

    /**
     * Message key
     * @param messageType The message type
     * @param messageKey The message key
     * @param position The message position in page
     * @param stateName The state name
     * @param isClosable The isClosable
     */
    constructor(messageType: MessageType, messageTextKey: string, position: MessagePositionEnum, stateName: string, isClosable?: boolean) {
        this.messageTextKey = messageTextKey;
        this.messageType = messageType;
        this.position = position;
        this.stateName = stateName;
        this.isClosable = isClosable !== undefined ? isClosable : true;
    }
}